import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import LeaveCodeHeader from '@hr/components/LeaveCode/LeaveCodeHeader.vue';
import LeaveCodeList from '@hr/components/LeaveCode/LeaveCodeList.vue';
import PageNavigationBar from '@appbase/components/Paginate/PageNavigationBar.vue';
import api from '@hr/api';
import * as dateutil from '@appbase/util/date-helper'
import { mapGetters } from 'vuex';
import * as accountTypes from '@account/store/types';


@Component ({
    components: { LeaveCodeHeader, LeaveCodeList, PageNavigationBar },
    computed: mapGetters({
        user: accountTypes.CURRENT
    }),
})
export default class LeaveCodeContainer extends Vue {
    user!: account.TCurrent
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    items: Array<any> = [];
    totalCount: number = 0;
    pageNum: number = 1;
    rowSize: number = 20;

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    load(data: any) {
        const {pageNum, rowSize, comCode} = data;

        api.leave.getLeaveCodeList(pageNum, rowSize, comCode).then((res: any) => {
            if (res) {
                    this.items = res.items;
                    this.totalCount = res.totalCount;
            }
        });
    }

    pageMove(number: number) {
        var data = {
            pageNum: number,
            rowSize: this.rowSize,
            comCode: this.user.company.comCode
        }
        this.load(data);
    }


    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y L E : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    mounted() {

    }

    created() {
        this.setPage({title:this.$t('휴가코드관리')});
        var data = {
            pageNum: this.pageNum,
            rowSize: this.rowSize,
            comCode: this.user.company.comCode
        }
        this.load(data);
    }
}
